import { render, staticRenderFns } from "./ActivityLargeImage.vue?vue&type=template&id=068d1efa&scoped=true"
import script from "./ActivityLargeImage.vue?vue&type=script&lang=ts"
export * from "./ActivityLargeImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLargeImage.vue?vue&type=style&index=0&id=068d1efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d1efa",
  null
  
)

export default component.exports